import { Badge, type BadgeTone } from "@constructorfleet/ui";

export function StatusBadge({ status }: { status: string }) {
  const tone = getStatusTone(status);

  return (
    <Badge className="settings-badge" tone={tone}>
      {status}
    </Badge>
  );
}

export function DiscrepancyBadge({
  providerActive,
  dbStatus,
}: {
  providerActive: boolean;
  dbStatus: string | null;
}) {
  const providerTerminal = !providerActive;
  const dbTerminal = dbStatus === "completed" || dbStatus === "failed";

  if (providerTerminal && !dbTerminal && dbStatus) {
    return (
      <Badge
        className="settings-badge"
        tone="danger"
        variant="subtle"
        title="Provider shows call ended but database still shows active"
      >
        Provider ended / DB active
      </Badge>
    );
  }

  if (!providerTerminal && dbTerminal) {
    return (
      <Badge
        className="settings-badge"
        tone="warning"
        variant="subtle"
        title="Provider shows call active but database shows terminal"
      >
        Provider active / DB terminal
      </Badge>
    );
  }

  if (!providerActive && !dbStatus) {
    return (
      <Badge
        className="settings-badge"
        tone="neutral"
        variant="subtle"
        title="Call from provider only, no database record"
      >
        Provider only
      </Badge>
    );
  }

  if (providerActive && dbStatus && !dbTerminal) {
    return (
      <Badge className="settings-badge" tone="success" variant="subtle">
        In sync
      </Badge>
    );
  }

  return null;
}

function getStatusTone(status: string): BadgeTone {
  if (status === "in-progress" || status === "processing" || status === "initiated") {
    return "info";
  }

  if (status === "queued") {
    return "warning";
  }

  if (status === "completed") {
    return "success";
  }

  if (status === "failed") {
    return "danger";
  }

  return "default";
}
